/* eslint-disable */
import React, { useEffect } from "react";
import { getCommunityFunds } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const Payments = ({ getCommunityFunds, communityFunds, period }) => {
  useEffect(() => {
    getCommunityFunds({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityFunds(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityFunds(payload);
  };

  return (
    <DataTable
      preset="payments"
      data={{
        docs: communityFunds?.docs || [],
        totalPages: communityFunds?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityFunds: state.appCommunities.communityFunds,
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityFunds: (payload) => dispatch(getCommunityFunds(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payments);
